import { Component, Input } from "@angular/core";

@Component({
  selector: "det-popover",
  templateUrl: "./determinant-popover.component.html",
})

export class DeterminantPopoverComponent {

  @Input() public determinant: any;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public extraClasses: string = "";
  @Input() public placement: string = "right";
  @Input() public noneSelectedText: string = "Add determinant";
  @Input() public showDeterminant: boolean = false;
  @Input() public hasErrors: boolean = false;
  @Input() public regularSpaces: boolean = true;

}
